var mobilizedAds = [];
jjAdManager = {
    Config: {
        GetServiceUrl: function () {
            if (window.location.hostname == "playground.jaktojagare.se") {
                return "https://playground.jaktojagare.se/wp-json/";
            }
            else if (window.location.hostname == "eldev.jaktojagare.se") {
                return "https://eldev.jaktojagare.se/wp-json/";
            }
            else {
                return "https://www.jaktojagare.se/wp-json/";
            }
        },
        GetMobileBreakpoint: function() {return 1024;}
    },
    TakeOverAdLoader: {
        Init: function() {
            var ad_maxads = 1;
            var cookiesAllowed = jjAdManager.TakeOverAdLoader.cookiesAllowed();

            if (cookiesAllowed) {
                var c = (jQuery).cookie("jj-ad-takeover-displayed");
                if (c == null) {
                    jQuery.get(jjAdManager.Config.GetServiceUrl() + "ads/list?datasource=takeover", function (data) {
                        var counter=0;
                        data.ads.forEach(ad => {
                            ad.is_user_logged_in = is_user_logged_in;
                            counter++;
                            if(counter<=ad_maxads) {
                                jQuery.get("/wp-content/themes/jaktojagare.se/templates/ad_takeover.html", function (template) {
                                    jQuery('body').append(Mustache.render(template, ad));
                                    jQuery('body').css('overflow', 'hidden');
                                });
                            }
                        });
                    });
                    
                    var date = new Date();
                    var minutes = 240; //2520;
                    date.setTime(date.getTime() + (minutes * 60 * 1000));

                    jQuery.cookie("jj-ad-takeover-displayed", true, { path: "/", expires: date });
                }
            }
        },
        closeTakeOverAd: function() {
            jQuery("#takeoverWindow").removeClass("ad-takeover-window");
            jQuery("body").css("overflow", "auto");
            jQuery("#takeoverWindow").html("");
        },
        cookiesAllowed: function () {
            if (navigator.cookieEnabled) return true;

            document.cookie = "cookietest=1";
            var ret = document.cookie.indexOf("cookietest=") != -1;
            document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
            return ret;
        }
    },
    AdLoader: {
        Init: function() {
            var adAreas = document.getElementsByClassName('mb-adarea');
            
            adAreas.forEach(area => {
                jjAdManager.AdLoader.RenderAds(area);
            });

            var BreakPoint = jjAdManager.Config.GetMobileBreakpoint();

            if (jQuery(window).width() < BreakPoint) {
                this.setAdSizeToMobile();
            }

            if (jQuery(window).width() > BreakPoint) {
                this.setAdSizeToLarge();
            }

            jQuery(window).resize(function () {
                if (jQuery(window).width() < BreakPoint) {
                    jjAdManager.AdLoader.setAdSizeToMobile();
                }
                if (jQuery(window).width() > BreakPoint) {
                    jjAdManager.AdLoader.setAdSizeToLarge();
                }
            });
        },
        setAdSizeToLarge: function () {
            jQuery('img.ad').each(function (i, obj) {
                var srcLarge = obj.getAttribute("data-version-large");
                obj.src = srcLarge;
            });
        },

        setAdSizeToMobile: function () {
            jQuery('img.ad').each(function (i, obj) {
                var srcMobile = obj.getAttribute("data-version-mobile");
                obj.src = srcMobile;
            });
        },
        RenderAds: function(area) {
            var ad_datasource = area.dataset.adDatasource;
            var ad_area = area.dataset.adArea;
            var ad_maxads = area.dataset.adMaxads;
            var ad_displayon = area.dataset.adDisplayon;
            var ad_slot = area.dataset.adSlot;

            var excludeInternalAds = false;
            var excludedAdId = 0;
            if(ad_area == 'nyhetsflode_mobil') {
                excludeInternalAds=true;
            }

            jQuery.get(jjAdManager.Config.GetServiceUrl() + "ads/list?datasource=" + ad_datasource + '&excludeinternal=' + excludeInternalAds, function (data) {
                var BreakPoint = jjAdManager.Config.GetMobileBreakpoint();
                
                var counter = 0;
                data.ads.forEach(ad => {
                    var displayAd = true;
                    if(mobilizedAds.includes(ad.id) && ad_area == 'nyhetsflode_mobil') {
                        displayAd=false;
                    }
                    ad.is_user_logged_in = is_user_logged_in;
                    if(displayAd) {
                        counter++;
                        if(counter<=ad_maxads) {
                            if(ad_area == 'nyhetsflode_mobil') {
                                mobilizedAds.push(ad.id);
                            }

                            var el = jQuery('<div></div>').appendTo(jQuery(area));

                            jQuery.get("/wp-content/themes/jaktojagare.se/templates/ad_" + ad_area + ".html", function (template) {
                                jQuery(el).append(Mustache.render(template, ad));

                                if (jQuery(window).width() < BreakPoint) {
                                    jjAdManager.AdLoader.setAdSizeToMobile();
                                }

                                if (jQuery(window).width() > BreakPoint) {
                                    jjAdManager.AdLoader.setAdSizeToLarge();
                                }
                            });
                        }
                    }
                });
            });
        }
    }

}
var jj = jjAdManager || {};
jQuery(function() {
    jj.AdLoader.Init();
    jj.TakeOverAdLoader.Init();
});
